// 2020-06-27export { MyColButtonComponent } from './my-col-button.component';